import { ConnectionTransport } from './connection.transport';
export class ConnectionTransports {
private static transports: ConnectionTransport[] =
        [
            new ConnectionTransport("foreverFrame"),
            new ConnectionTransport("longPolling"),
            new ConnectionTransport("serverSentEvents"),
            new ConnectionTransport("webSockets"),
            new ConnectionTransport("auto"),
        ];
/**
 * @return {?}
 */
public static get foreverFrame(): ConnectionTransport {
        return ConnectionTransports.transports[0];
    }
/**
 * @return {?}
 */
public static get longPolling(): ConnectionTransport {
        return ConnectionTransports.transports[1];
    }
/**
 * @return {?}
 */
public static get serverSentEvents(): ConnectionTransport {
        return ConnectionTransports.transports[2];
    }
/**
 * @return {?}
 */
public static get webSockets(): ConnectionTransport {
        return ConnectionTransports.transports[3];
    }
/**
 * @return {?}
 */
public static get auto(): ConnectionTransport {
        return ConnectionTransports.transports[4];
    }
}

function ConnectionTransports_tsickle_Closure_declarations() {
/** @type {?} */
ConnectionTransports.transports;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
